import { Action } from "redux"
import { Collection, CollectionView, IItem } from "../../models"
import { IButton, ICallButton } from "../common/contextmenu"
import { ILinkedDocument } from "../inlineattachments"

export const INITIALIZE = "CARDVIEW_INITIALIZE"

export interface Initialize extends Action {
    collection: Collection
}

export const initialize = (collection: Collection): Initialize => ({
    type: INITIALIZE,
    collection,
})

export const RELOAD = "CARDVIEW_RELOAD"

export const reload = (): Action => ({ type: RELOAD })

export const LOAD_MORE = "CARDVIEW_LOAD_MORE"

export const loadMore = (): Action => ({
    type: LOAD_MORE,
})

export const REQUEST_DATA = "CARDVIEW_REQUEST_DATA"

export const requestData = (): Action => ({
    type: REQUEST_DATA,
})

export const RECEIVE_DATA = "CARDVIEW_RECEIVE_DATA"

export interface CollectionViewDataAction extends Action {
    data: CollectionView
}

export const receiveData = (
    data: CollectionView,
): CollectionViewDataAction => ({
    type: RECEIVE_DATA,
    data,
})

export const REPLACE_DATA = "CARDVIEW_REPLACE_DATA"

export const replaceData = (
    data: CollectionView,
): CollectionViewDataAction => ({
    type: REPLACE_DATA,
    data,
})

export const REFRESH_ITEMS = "CARDVIEW_REFRESH_ITEMS"

export interface ItemsAction extends Action {
    itemIds: number[]
}

export const refreshItems = (itemIds: number[]): ItemsAction => ({
    type: REFRESH_ITEMS,
    itemIds,
})

export const RECEIVE_ITEMS = "CARDVIEW_RECEIVE_ITEMS"

export interface ReceiveItemsAction extends Action {
    items: IItem[]
}

export const receiveItems = (items: IItem[]): ReceiveItemsAction => ({
    type: RECEIVE_ITEMS,
    items,
})

export const REMOVE_ITEM = "CARDVIEW_REMOVE_ITEM"

export const removeItem = (itemId: number): ItemAction => ({
    type: REMOVE_ITEM,
    itemId,
})

export const HIDE_CONTEXT_MENU = "CARDVIEW_HIDE_CONTEXTMENU"

export interface ItemAction extends Action {
    itemId: number
}

export const hideContextMenu = (itemId: number): ItemAction => ({
    type: HIDE_CONTEXT_MENU,
    itemId,
})

export const SHOW_CONTEXT_MENU = "CARDVIEW_SHOW_CONTEXTMENU"

export interface ItemAction extends Action {
    itemId: number
}

export const showContextMenu = (itemId: number): ItemAction => ({
    type: SHOW_CONTEXT_MENU,
    itemId,
})

export const RECEIVE_CONTEXTMENU_DATA = "CARDVIEW_RECEIVE_CONTEXTMENU_DATA"

export interface ContextMenuAction extends Action {
    itemId: number
    buttons: IButton[]
}

export const receiveContextMenu = (
    itemId: number,
    buttons: IButton[],
): ContextMenuAction => ({
    type: RECEIVE_CONTEXTMENU_DATA,
    itemId,
    buttons,
})

export const EXECUTE_CONTEXTMENU_ACTION = "CARDVIEW_EXECUTE_CONTEXTMENU_CALL"

export interface ContextMenuCallAction extends Action {
    itemId: number
    button: ICallButton
}

export const executeAction = (
    itemId: number,
    button: ICallButton,
): ContextMenuCallAction => ({
    type: EXECUTE_CONTEXTMENU_ACTION,
    itemId,
    button,
})

export interface RequestAttachments extends Action {
    itemId: number
    encodeDescription: boolean
}

export const REQUEST_ATTACHMENTS = "CARDVIEW_REQUEST_ATTACHMENTS"

export const requestAttachments = (
    itemId: number,
    encodeDescription: boolean,
): RequestAttachments => ({
    type: REQUEST_ATTACHMENTS,
    itemId,
    encodeDescription,
})

export interface ReceiveAttachments extends Action {
    itemId: number
    linkedDocuments: ILinkedDocument[]
}

export const RECEIVE_ATTACHMENTS = "CARDVIEW_RECEIVE_ATTACHMENTS"

export const receiveAttachments = (
    itemId: number,
    linkedDocuments: ILinkedDocument[],
): ReceiveAttachments => ({
    type: RECEIVE_ATTACHMENTS,
    itemId,
    linkedDocuments,
})

export const REQUEST_ADD_ATTACHMENT = "CARDVIEW_REQUEST_ADD_ATTACHMENT"

export interface RequestAddAttachment extends Action {
    itemId: number
    formData: FormData
}

export const requestAddAttachment = (
    itemId: number,
    formData: FormData,
): RequestAddAttachment => ({
    type: REQUEST_ADD_ATTACHMENT,
    itemId,
    formData,
})

export const REQUEST_DELETE_ATTACHMENT = "CARDVIEW_REQUEST_DELETE_ATTACHMENT"

export interface RequestDeleteAttachment extends Action {
    itemId: number
    linkedDocumentId: number
}

export const requestDeleteAttachment = (
    itemId: number,
    linkedDocumentId: number,
): RequestDeleteAttachment => ({
    type: REQUEST_DELETE_ATTACHMENT,
    itemId,
    linkedDocumentId,
})

export const UPDATE_ATTACHMENT_DESCRIPTION =
    "CARDVIEW_UPDATE_ATTACHMENT_DESCRIPTION"

export interface UpdateAttachmentDescription extends Action {
    itemId: number
    objectId: number
    value: string
}

export const updateAttachmentDescription = (
    itemId: number,
    objectId: number,
    value: string,
): UpdateAttachmentDescription => ({
    type: UPDATE_ATTACHMENT_DESCRIPTION,
    itemId,
    objectId,
    value,
})

export const mapDispatchToProps = {
    initialize,
    requestData,
    receiveData,
    loadMore,
    showContextMenu,
    hideContextMenu,
    executeAction,
    requestAttachments,
    receiveAttachments,
    requestAddAttachment,
    requestDeleteAttachment,
    updateAttachmentDescription,
}

export type DispatchProps = typeof mapDispatchToProps
